<template>
  <FITFormCard>
    <div slot="header">
      <h4>{{ $t('adm.userAuthorization.change.header') }}</h4>
    </div>
    <div slot="formBody">
      <AuthorizationChange :candidates="fakeCandidates" :callback="callback"></AuthorizationChange>
    </div>
  </FITFormCard>
</template>
<script>
import { FITFormCard } from '@/components'
import AuthorizationChange from './AuthorizationChange'
export default {
  name: 'AuthorizationChangeWrapper',
  components: {
    AuthorizationChange,
    FITFormCard
  },
  props: {
    candidate: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      callback: {
        onSuccess: (data) => {
          this.$router.go(-1);
        },
        onError: (error) => {
          console.debug(err)
        }
      }
    }
  },
  computed: {
    fakeCandidates() {
      return [this.candidate]
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Adm/UserAuthorization/components/AuthorizationChangeWrapper.vue